/**
 * HeroBanner — page-level hero with optional status chip, headline, and sub-copy.
 */

import React from 'react';

export type ChipVariant = 'primary' | 'teal' | 'amber';

const chipStyles: Record<ChipVariant, React.CSSProperties> = {
  primary: {
    background: 'linear-gradient(135deg, #5b6cff, #7c8eff)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(91,108,255,0.30)',
  },
  teal: {
    background: 'linear-gradient(135deg, #00b89a, #00c2a8)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(0,194,168,0.28)',
  },
  amber: {
    background: 'linear-gradient(135deg, #f59e0b, #f97316)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(245,158,11,0.30)',
  },
};

interface HeroBannerProps {
  headline: string;
  sub: string;
  chip?: string;
  chipVariant?: ChipVariant;
  animDelay?: number;
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
  headline,
  sub,
  chip,
  chipVariant = 'primary',
  animDelay = 0,
}) => {
  return (
    <div
      className="db-fade-up mb-8"
      style={{ animationDelay: `${animDelay}ms` }}
    >
      {chip && (
        <div className="mb-4">
          <span
            className="inline-flex items-center px-4 py-1.5 rounded-full font-montserrat font-bold text-sm"
            style={chipStyles[chipVariant]}
          >
            {chip}
          </span>
        </div>
      )}
      <h1
        className="font-montserrat font-extrabold text-3xl md:text-4xl text-neutral-800 leading-tight mb-3"
      >
        {headline}
      </h1>
      <p className="font-open-sans text-lg text-neutral-600 max-w-2xl leading-relaxed">
        {sub}
      </p>
    </div>
  );
};
